
import { cookieGet } from '@/common/cookie';

import axios from 'axios';

const mediaAccessKey = '1502637b3f2c4288b22e9f04efed60c1';

export default async function uploadHelper(file, customUrl) {
    const token = cookieGet('token');
    console.log('token:' + token);
    const header = { 'Content-Type': 'multipart/form-data' };
    // if (token) {
    //     header.Cookie = 'token=' + (token || '')
    // }

    const mediaApiUrl = '/media/upload/';
    var url = `${mediaApiUrl}${mediaAccessKey}/`;
    if (customUrl) {
      url = customUrl;
    }
    console.log('url:' + url);
    const fullUrl = axios.defaults.baseMediaURL + url;
    const data = new FormData();
    data.append('file', file);

    return new Promise((resolve, reject) => {
        axios.post(fullUrl, data, {
          headers: header,
          timeout: 1000 * 10
        }).then(res => {
          console.log(res.data.data);
          if (res.data.code === 0 || res.data.code === 200) {
            resolve(res.data.data);
          } else {
            resolve({});
          }
        }).catch(err => {
          console.log(err);
        });
    });
}
